// extracted by mini-css-extract-plugin
module.exports = {"products":"QC-z","misad":"RC-z","oosMessaging":"SC-z","topProductFrame":"TC-z","productCardOverrides":"UC-z","secondRowAds":"VC-z","microsoftAdsWrapper":"WC-z"};